
import axios, { AxiosResponse } from "axios";

import client from '../axios.setup';

const AUTHENTICATOR_BASE_URL = process.env.REACT_APP_AUTHENTICATOR_URL;

interface ITokenReques {
    appName: string;
    clientId: string,
    requestOrigin: string,
    redirectFailURL: string,
    redirectSuccessURL: string
}

export const genrateTokenAPI = async (modal: ITokenReques) => {
    try {
        const response: AxiosResponse =
            await axios.post(`${AUTHENTICATOR_BASE_URL}/AppRegistration/GenerateTokenCheckout`, modal);
        if (response.status === 200) {
            localStorage.setItem("pgvnext:pToken", response.data.data.accessToken);
            client.defaults.headers.common['Authorization'] = "Bearer " + response.data.data.accessToken;
        }
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const fetchPaymentLinkDetailAPI = async (
  id: string | null,
  language: string
) => {
  try {
    const response: AxiosResponse = await client.get(
      `api/v1/Partner/GetPaymentLinkDetails?paymentLinkId=${id}&language=${language}`
    );
    return response.data;
  } catch (err: any) {
    return Promise.reject(err.response.data);
  }
};

export const fetchLayoutAPI = async (id?: string, language?: string) => {
    try {
        const url = id ? `api/v1/Partner/GetStyleDefinitions?paymentLinkId=${id}&language=${language}` : `api/v1/Partner/GetStyleDefinitions?language=${language}`;
        const response: AxiosResponse = await client.get(url);
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const fetchPaymentPartnersAPI = (id: string | null) => {
    const url = id ? `api/v1/Partner/GetPaymentPartners?paymentLinkId=${id}` : "api/v1/Partner/GetPaymentPartners";
    return client.get(url);
}

export const phoneVerificationAPI = async (phoneNumber: string, lang: string, source: string) => {
    try {
        const response = await client.post(`api/v1/Partner/GetUserInfo`, {
            "Phone": phoneNumber,
            "Language": lang,
            source
        });
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const merchantPaymentAPI = async (modal: any) => {
    try {
        const response = await client.post(`api/v1/Partner/MerchantPayment`, modal);
        if (response.status === 200) {
            console.log("response....", response)
            return response.data;
        }
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const merchantPaymentAPIV2 = async (modal: any) => {
    try {
        const response = await client.post(`api/v2/Azampesa/MerchantPayment`, modal);
        if (response.status === 200) {
            console.log("response....", response)
            return response.data;
        }
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const mnoCheckoutAPI = async (modal: any) => {
    try {
        const response = await client.post(`api/v1/Checkout/CheckoutMno`, modal);
        if (response.status === 200) {
            return response.data;
        }
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const getCheckoutAPI = async (search: any) => {
    try {
        const response = await client.get(`api/v1/Partner/GetCheckout${search}`);
        if (response.status === 200) {
            return response.data;
        }
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const getTransactionStatusAPI = async (transactionId: string | null, provider: string | null) => {
    try {
        const response = await client.get(`api/v1/Partner/GetTransactionStatus?transactionId=${transactionId}&provider=${provider}`);
        if (response.status === 200) {
            return response.data;
        }
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}


export const verifyBank = async (modal: any) => {
    try {
        const response = await client.post(`/azampay/bankv2/verify`, modal);
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

export const checkoutBank = async (modal: any) => {
    try {
        const response = await client.post(`/azampay/bankv2/checkout`, modal);
        return response.data;
    } catch (err: any) {
        return Promise.reject(err.response.data);
    }
}

